var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 61,
    viewBox: "0 0 51 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 46.7C49.0333 47.2667 48.0833 47.7 46.95 48C45.85 48.2667 44.7 48.4 43.5 48.4C40.2667 48.4 37.7833 47.5833 36.05 45.95C34.3167 44.3167 33.45 41.9167 33.45 38.75V15.15H41.25V21.7H47.9V27.7H41.25V38.65C41.25 39.7833 41.5333 40.6667 42.1 41.3C42.6667 41.9 43.4833 42.2 44.55 42.2C45.75 42.2 46.8167 41.8667 47.75 41.2L49.8 46.7Z",
    fill: "#B9D0FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.62268e-07 20C-1.17422e-07 18.3431 1.34315 17 3 17L21 17C22.6569 17 24 18.3431 24 20C24 21.6569 22.6569 23 21 23L3 23C1.34315 23 -4.07115e-07 21.6569 -2.62268e-07 20Z",
    fill: "#647BF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 32C10.5 30.3431 11.8431 29 13.5 29L21 29C22.6569 29 24 30.3431 24 32C24 33.6569 22.6569 35 21 35H13.5C11.8431 35 10.5 33.6569 10.5 32Z",
    fill: "#647BF0",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 44C1.5 42.3431 2.84315 41 4.5 41H20.901C22.5578 41 23.901 42.3431 23.901 44C23.901 45.6569 22.5578 47 20.901 47H4.5C2.84315 47 1.5 45.6569 1.5 44Z",
    fill: "#647BF0",
    fillOpacity: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3b1b9f955c47c5852741488b6b46c60.svg";
export { ForwardRef as ReactComponent };